import Quickpick from './Quickpick';

export default Quickpick;
